var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "questionPreview" }, [
    _c("div", { staticClass: "title" }, [
      _c("p", [_vm._v("题型：" + _vm._s(_vm.questionObj.questionTypeName))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "难度：" +
            _vm._s(
              _vm.questionObj.difficulty == 1
                ? "简单"
                : _vm.questionObj.difficulty == 2
                ? "中等"
                : "困难"
            )
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("建议分数：" + _vm._s(_vm.questionObj.score))]),
      _vm._v(" "),
      _c("p", [_vm._v("创建人：" + _vm._s(_vm.questionObj.createName))]),
      _vm._v(" "),
      _c("p", [_vm._v("创建时间：" + _vm._s(_vm.questionObj.createTime))])
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.questionObj.internalTypeId != 6
        ? _c("div", { staticClass: "questionInfo single_question" }, [
            _c("p", { staticClass: "question_title" }, [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "calc(100% - 80px)"
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.questionObj.taskName
                          ? "【" + _vm.questionObj.taskName + "】"
                          : _vm.questionObj.taskName
                      )
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "div_content ql-editor",
              domProps: { innerHTML: _vm._s(_vm.questionObj.questionContent) }
            }),
            _vm._v(" "),
            _vm.questionObj.internalTypeId === 1 ||
            _vm.questionObj.internalTypeId === 2
              ? _c(
                  "ul",
                  _vm._l(_vm.questionObj.items, function(option, option_index) {
                    return _c("li", {
                      key: option_index,
                      class: {
                        actived:
                          _vm.questionObj.questionAnswer.indexOf(
                            option.itemKey
                          ) != -1
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          option.itemKey + ". " + option.itemValue
                        )
                      }
                    })
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "answer" }, [
              _c(
                "p",
                [
                  _c("span", { staticClass: "label" }, [_vm._v("【知识点】:")]),
                  _vm._v(" "),
                  _vm._l(_vm.questionObj.materials, function(
                    material,
                    mat_index
                  ) {
                    return _c(
                      "span",
                      { key: mat_index },
                      [
                        material
                          ? _c(
                              "el-tag",
                              {
                                staticClass: "my_tag",
                                attrs: { size: "mini", title: material.name }
                              },
                              [_vm._v(_vm._s(material.name))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("【公司】:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.questionObj.companyNameUp))])
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("span", { staticClass: "label" }, [_vm._v("【标签】:")]),
                  _vm._v(" "),
                  _vm._l(_vm.questionObj.personLabels, function(
                    personLabel,
                    personLabel_index
                  ) {
                    return _c(
                      "el-tag",
                      {
                        key: personLabel_index,
                        staticClass: "my_tag",
                        attrs: { size: "mini", title: personLabel.labelName }
                      },
                      [_vm._v(_vm._s(personLabel.labelName))]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("【备注】:")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(" 修改人：" + _vm._s(_vm.questionObj.updateName) + " ")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "updateTime" }, [
                  _vm._v(
                    "\n            修改时间：" +
                      _vm._s(_vm.questionObj.updateTime) +
                      "\n          "
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.questionObj.internalTypeId == 6
        ? _c(
            "div",
            { staticClass: "questionInfo group_question" },
            [
              _c("p", { staticClass: "question_title" }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "calc(100% - 80px)"
                    }
                  },
                  [
                    _vm._v("\n          【"),
                    _c("span", [_vm._v(_vm._s(_vm.questionObj.taskName))]),
                    _vm._v("】\n        ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "div_content ql-editor",
                domProps: { innerHTML: _vm._s(_vm.questionObj.questionContent) }
              }),
              _vm._v(" "),
              _vm._l(_vm.questionObj.childQuestions, function(
                childQuestion,
                cq_index
              ) {
                return _c(
                  "div",
                  { key: cq_index, staticClass: "questionInfo" },
                  [
                    _c("p", { staticClass: "flex_header" }, [
                      childQuestion.internalTypeId === 1
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【单选题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 2
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【多选题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 3
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【判断题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 4
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【填空题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 5
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【简答题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 9
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【实操题】")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      childQuestion.internalTypeId === 10
                        ? _c("span", { staticClass: "testDetail" }, [
                            _vm._v(_vm._s(cq_index + 1) + "、【附件题】")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "div_content ql-editor",
                      domProps: {
                        innerHTML: _vm._s(childQuestion.questionContent)
                      }
                    }),
                    _vm._v(" "),
                    childQuestion.internalTypeId === 1 ||
                    childQuestion.internalTypeId === 2
                      ? _c(
                          "ul",
                          _vm._l(childQuestion.items, function(
                            option,
                            op_index
                          ) {
                            return _c("li", {
                              key: op_index,
                              class: {
                                actived:
                                  childQuestion.questionAnswer.indexOf(
                                    option.itemKey
                                  ) != -1
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  option.itemKey + ". " + option.itemValue
                                )
                              }
                            })
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "answer" }, [
                _c(
                  "p",
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("【知识点】:")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.questionObj.materials, function(
                      material,
                      m_index
                    ) {
                      return _c(
                        "span",
                        { key: m_index },
                        [
                          material
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "my_tag",
                                  attrs: { size: "mini", title: material.name }
                                },
                                [_vm._v(_vm._s(material.name))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("【公司】:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.questionObj.companyNameUp) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("【标签】:")]),
                    _vm._v(" "),
                    _vm._l(_vm.questionObj.personLabels, function(
                      personLabel,
                      personLabel_index
                    ) {
                      return _c(
                        "el-tag",
                        {
                          key: personLabel_index,
                          staticClass: "my_tag",
                          attrs: { size: "mini", title: personLabel.labelName }
                        },
                        [_vm._v(_vm._s(personLabel.labelName))]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("【备注】:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      " 修改人：" + _vm._s(_vm.questionObj.updateName) + " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "updateTime" }, [
                    _vm._v(
                      "\n            修改时间：" +
                        _vm._s(_vm.questionObj.updateTime) +
                        "\n          "
                    )
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c49df086", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c49df086","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/question/questionPreview.vue
// module id = null
// module chunks = 